import * as React from 'react'
import { withConfig } from  '../../common/modules/config'
import StandardInput from '../components/standard-input'
import Validation from '../../common/modules/validation/rules'
import Recaptcha from '../components/recaptcha'
import CheckboxInput from '../components/checkbox-input'
import StepTitle from '../components/step-title'
import SubHeader from '../components/sub-header'
import StepBlock from '../components/step-block'
import Button from '../components/button'
import { withScrollToTop } from '../../common/modules/scroll-to-top'
import { withNavigation } from '../../common/modules/navigation'


@withScrollToTop
@withNavigation
class Declined extends React.Component<any, any>{

    
    
    

    render(){
        return (
            <div className="row">
                <StepTitle>Sorry</StepTitle>
                
                <StepBlock>
                    <p>We are unable to provide you with a quote for a policy at this location.</p>
                </StepBlock>

                <Button.Container>
                    <a href="http://www.chu.com.au/" className="btn btn-primary btn-lg mt-2">Return Home</a>
                </Button.Container>
            </div>
        )
    }

}


export default Declined;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/routes/declined.tsx